import { Link } from "react-router-dom";
import { PhoneCall, MessageSquare, Calendar } from "lucide-react";
import { CLINIC } from "@/data/content";

const MobileBottomBar = () => (
  <nav
    data-testid="mobile-bottom-bar"
    className="fixed bottom-0 inset-x-0 z-50 md:hidden bg-slate-950/95 backdrop-blur-lg border-t border-slate-800 px-3 pt-2.5 pb-[max(0.625rem,env(safe-area-inset-bottom))] shadow-2xl"
  >
    <div className="flex items-center gap-2">
      <a
        href={`tel:${CLINIC.phoneRaw}`}
        data-testid="mobile-bar-call"
        className="flex-1 py-2.5 rounded-xl bg-slate-800 text-slate-100 text-xs font-semibold flex items-center justify-center gap-1.5 active:bg-slate-700"
      >
        <PhoneCall className="w-4 h-4" /> CALL
      </a>
      <a
        href={CLINIC.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-bar-whatsapp"
        className="flex-1 py-2.5 rounded-xl bg-emerald-700 text-white text-xs font-semibold flex items-center justify-center gap-1.5 active:bg-emerald-600"
      >
        <MessageSquare className="w-4 h-4" /> WHATSAPP
      </a>
      <Link
        to="/booking?type=online"
        data-testid="mobile-bar-book"
        className="flex-1 py-2.5 rounded-xl bg-amber-600 text-white text-xs font-semibold flex items-center justify-center gap-1.5 active:bg-amber-500"
      >
        <Calendar className="w-4 h-4" /> BOOK
      </Link>
    </div>
  </nav>
);

export default MobileBottomBar;
